import get from 'lodash.get';

const getGTM = (rootState) => get(rootState, 'config.common.google-tag-manager');

export default getGTM;
